/*
 * Novicell master
 *  Author: APN modified by DLA
 *  Use this file to call functions in other files, on document ready, window.resize etc.
 *  ------
 * Dependencies: jquery, novicell.js, other files with awesome functions.
 *  Usage: $(function () {
 *              something.slider.heroSlider($('.owl-carousel'));
 *         }); // Document ready end
 */

var novicell = novicell || {};
var ostbv = ostbv || {};

// Document ready
$(function () {

    novicell.responsive.init();

    // Call new funtions here like this:
    ostbv.navigation.dropdown($('#navigation-list >li'));

    ostbv.navigation.init();
    ostbv.formlist.tabs();
    novicell.lazyload.box('.service-item, .news-item, .case-item, .employee-item');
    novicell.cookieInfo.init();


    if ($('.testimonials .owl-carousel').length) {
        ostbv.slider.testimonialSlider($('.testimonials .owl-carousel'));
    }

    svg4everybody();

    presentation();
    if ($("#map-canvas").length) {
        initMaps();
    }

}); // Document ready end



// Window load
$(window).load(function (e) {

}); // Window load 


// Window scroll
$(window).scroll(function (e) {
    novicell.lazyload.box('.service-item, .news-item, .case-item, .employee-item');
});


function presentation() {

    if ($('#stations-filter').length) {
        var filter = $('#stations-filter');
        var activeFilter = $('.active', filter).data('filter');
        var stations = $('.stations');
        var lat = $('.active', filter).data('lat');
        var lng = $('.active', filter).data('lng');

        //initial filter
        $('.station-container', stations).each(function () {
            var current = $(this);
            if ($(current).hasClass('filter-' + activeFilter + '')) {
                $(current).addClass('active');
            }
        });

        $('#map-canvas').attr('data-lat', lat);
        $('#map-canvas').attr('data-lng', lng);

        //select filter
        $("body").on("click", '.filter span', filter, function () {
            if (!$(this).hasClass('active')) {

                var currentFilter = $(this);
                var activeFilter = $(currentFilter).data('filter');

                var currentLat = $(currentFilter).data('lat');
                var currentLng = $(currentFilter).data('lng');

                $('.active', filter).removeClass('active');
                $(currentFilter).addClass('active');

                $('#map-canvas').attr('data-lat', currentLat);
                $('#map-canvas').attr('data-lng', currentLng);


                //initial filter
                $('.station-container', stations).removeClass('active');
                $('.station-container', stations).each(function () {
                    var currentStation = $(this);
                    if ($(currentStation).hasClass('filter-' + activeFilter + '')) {
                        $(currentStation).addClass('active');
                    }
                });

            }
            initMaps();
        });
    }
}

function initMaps() {
    var locations = "";

    console.log(locations);
    // Get map element from HTML
    var mapElement = document.getElementById('map-canvas');

    function initialize() {

        // Get lat / lng form the map element's attributes
        var lat = parseFloat(mapElement.getAttribute('data-lat').replace(',', '.')),
            lng = parseFloat(mapElement.getAttribute('data-lng').replace(',', '.'));

        var coordinates = new google.maps.LatLng(lat, lng);

        // Snazzymaps styles
        // https://snazzymaps.com/style/28228/simply-transport
        var mapStyles = [
            { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{ "color": "#444444" }] },
            { "featureType": "landscape", "elementType": "all", "stylers": [{ "color": "#f2f2f2" }] },
            { "featureType": "landscape.man_made", "elementType": "all", "stylers": [{ "visibility": "off" }] },
            { "featureType": "landscape.natural.landcover", "elementType": "all", "stylers": [{ "visibility": "off" }] },
            { "featureType": "landscape.natural.terrain", "elementType": "all", "stylers": [{ "visibility": "off" }] },
            { "featureType": "poi", "elementType": "all", "stylers": [{ "visibility": "off" }] },
            { "featureType": "poi.attraction", "elementType": "all", "stylers": [{ "visibility": "on" }, { "weight": "0.64" }] },
            { "featureType": "poi.park", "elementType": "all", "stylers": [{ "visibility": "simplified" }, { "lightness": "19" }, { "saturation": "0" }] },
            { "featureType": "poi.place_of_worship", "elementType": "all", "stylers": [{ "visibility": "off" }] },
            { "featureType": "road", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": 45 }, { "visibility": "on" }] },
            { "featureType": "road.highway", "elementType": "all", "stylers": [{ "visibility": "simplified" }] },
            { "featureType": "road.arterial", "elementType": "all", "stylers": [{ "visibility": "simplified" }] },
            { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] },
            { "featureType": "road.local", "elementType": "all", "stylers": [{ "visibility": "on" }] },
            { "featureType": "transit", "elementType": "all", "stylers": [{ "visibility": "off" }] },
            { "featureType": "transit.line", "elementType": "all", "stylers": [{ "visibility": "simplified" }, { "saturation": "0" }, { "lightness": "41" }, { "gamma": "1.27" }] },
            { "featureType": "transit.station.airport", "elementType": "all", "stylers": [{ "visibility": "on" }] },
            { "featureType": "transit.station.bus", "elementType": "all", "stylers": [{ "visibility": "on" }, { "hue": "#ff0000" }] },
            { "featureType": "transit.station.rail", "elementType": "all", "stylers": [{ "visibility": "on" }, { "saturation": "23" }, { "lightness": "0" }] },
            { "featureType": "water", "elementType": "all", "stylers": [{ "color": "#d3f3f4" }, { "visibility": "on" }] },
            { "featureType": "water", "elementType": "labels", "stylers": [{ "visibility": "off" }] },
            { "featureType": "water", "elementType": "labels.text", "stylers": [{ "color": "#ffffff" }, { "weight": "0.01" }, { "visibility": "off" }] }
        ];

        // Set map options
        var mapOptions = {
            zoom: 11,
            disableDefaultUI: false,
            draggable: false,
            scrollwheel: false,
            center: coordinates,
            styles: mapStyles
        };

        // Set icon
        var icon = {
            url: "/dist/images/map-marker.png",
            scaledSize: new google.maps.Size(44, 46)
        };

        // Set the google maps element
        var map = new google.maps.Map(mapElement, mapOptions);

        $('.stations .active.has-location').each(function () {
            var current = $(this);
            var lat = $(current).data('lat');
            var lng = $(current).data('lng');
            var coordinates = new google.maps.LatLng(lat, lng);
            var name = $(current).data('name');


            // Set marker
            var marker = new google.maps.Marker({
                position: coordinates,
                map: map,
                icon: icon,
                title: "" + name + ""
            });

        });

        // Recalculate center
        google.maps.event.addDomListener(window, "resize", function () {
            var center = map.getCenter();
            google.maps.event.trigger(map, "resize");
            map.setCenter(center);
        });
    }

    initialize();
}